// extracted by mini-css-extract-plugin
module.exports = {"Login":"login_Login__22iZ0","fade-in":"login_fade-in__OoK_e","submit":"login_submit__JpkD2"};